import { combineReducers } from 'redux';
import auth from './auth';
import wall from './wall';
import favs from './favs';
import groups from './groups';
import friends from './friends';
import notes from './notes';
import docs from './docs';
import videos from './videos';
import photos from './photos';
import downloader from './downloader';
import captcha from './captcha';

export default combineReducers({
  auth,
  wall,
  favs,
  groups,
  friends,
  notes,
  docs,
  videos,
  photos,
  downloader,
  captcha
})



// WEBPACK FOOTER //
// ./src/reducers/index.js